import { useEffect, useState } from 'react'
import { Table, Space, Pagination, Input, Col, Row, Select } from 'antd'
import { isEmpty, size, trim } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import { DELIVERY_CONST, PAGE_SIZE, getPage } from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { Loading } from '../../common'
import useWindowDimensions from '../../common/useWindowDimensions'
import { getMilestoneValue } from 'src/helpers/functions'
import moment from 'moment'

const ShipManagement = observer((props: any) => {
   const { t } = useTranslation()
   const OrdersStore = useStore('OrdersStore')
   const [textSearch, set_textSearch] = useState('')
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [isLoading, setIsLoading] = useState(false)
   const { height, width } = useWindowDimensions()
   const [fieldFilter, setFieldFilter] = useState<any>({})
   const { rows, offset, count } = OrdersStore.listShip

   useEffect(() => {
      if (size(trim(textSearch)) > 0) {
         getListData(0, { ...fieldFilter, ...{ keyword: trim(textSearch) } })
      } else {
         getListData(0, { ...fieldFilter })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [textSearch, fieldFilter])

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage)
         const params = { offset, ...param }
         // console.log('params', params)

         await OrdersStore.getShip(params)
      } catch (error) {
         // console.log(error)
      } finally {
         setIsLoading(false)
      }
   }

   const onChange = (currentPage: number) => {
      if (size(trim(textSearch)) > 0) {
         getListData(currentPage - 1, { ...fieldFilter, ...{ keyword: trim(textSearch) } })
      } else {
         getListData(currentPage - 1, { ...fieldFilter })
      }
   }

   const handleChangeTextSearch = (value: any) => {
      set_textSearch(value)
   }

   const columns = [
      {
         title: t(GLOBAL_CLIENT.id),
         dataIndex: 'id',
         key: 'id',
         align: 'center' as 'center',
         width: 50
         // fixed: 'left',
         //  render: (value: string, record: any, index: number) =>
         //      (page-1) * PAGE_SIZE + index + 1,
      },
      {
         title: 'Seller',
         dataIndex: 'account',
         key: 'account',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{value?.name || value?.email}</span>
         }
         // fixed: 'left',
      },
      {
         title: 'Order Id',
         dataIndex: 'code',
         width: 100,
         key: 'code',
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'Đối tác VC',
         dataIndex: 'deliveryPartner',
         width: 100,
         key: 'deliveryPartner',
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'TrackingID',
         dataIndex: 'trackingId',
         key: 'trackingId',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'Tracking status',
         dataIndex: 'trackingStatusName',
         width: 80,
         key: 'trackingStatusName',
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'Create date',
         dataIndex: 'createdAt',
         width: 80,
         key: 'createdAt',
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format('HH:mm DD/MM/YYYY')}</span>
         }
      },
      {
         title: 'Info received date',
         dataIndex: 'tracking',
         width: 80,
         key: 'tracking',
         render: (value: any) => {
            return (
               <span className="txtMax2Line">
                  {getMilestoneValue('InfoReceived', value?.data?.milestone)
                     ? moment(getMilestoneValue('InfoReceived', value?.data?.milestone), 'YYYY-MM-DDTHH:mm:ssZ').format(
                          'DD/MM/YYYY HH:mm'
                       )
                     : ''}
               </span>
            )
         }
      },
      {
         title: 'In transit date',
         dataIndex: 'tracking',
         width: 80,
         key: 'tracking',
         render: (value: any) => {
            return (
               <span className="txtMax2Line">
                  {getMilestoneValue('PickedUp', value?.data?.milestone)
                     ? moment(getMilestoneValue('PickedUp', value?.data?.milestone), 'YYYY-MM-DDTHH:mm:ssZ').format(
                          'DD/MM/YYYY HH:mm'
                       )
                     : ''}
               </span>
            )
         }
      },
      {
         title: 'Delivered date',
         dataIndex: 'tracking',
         key: 'tracking',
         width: 120,
         render: (value: any) => {
            return (
               <span className="txtMax2Line">
                  {getMilestoneValue('Delivered', value?.data?.milestone)
                     ? moment(getMilestoneValue('Delivered', value?.data?.milestone), 'YYYY-MM-DDTHH:mm:ssZ').format(
                          'DD/MM/YYYY HH:mm'
                       )
                     : ''}
               </span>
            )
         }
      },
      {
         title: 'Toàn trình',
         // Nếu đã giao thành công (getMilestoneValue('Delivered', ...) có giá trị):
         // → Tính số ngày từ createdAt đến ngày Delivered.
         // Nếu chưa giao:
         // → Tính số ngày từ createdAt đến ngày hiện tại.
         dataIndex: 'tracking',
         width: 80,
         key: 'tracking',
         render: (value: any, record: any) => {
            const deliveredDate = getMilestoneValue('Delivered', value?.data?.milestone)
            const createDate = record?.createdAt

            const start = moment(createDate)
            const end = deliveredDate ? moment(deliveredDate, 'YYYY-MM-DDTHH:mm:ssZ') : moment()

            const duration = end.diff(start, 'days')

            return <span className="txtMax2Line">{duration} ngày</span>
         }
      }
   ]

   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={offset / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }

   const handleChangeRole = (value: any) => {
      console.log('value', value)
      if (value == fieldFilter.deliveryPartner || !value) {
         let x = { ...fieldFilter }
         delete x['deliveryPartner']
         setFieldFilter(x)
      } else {
         setFieldFilter({ ...fieldFilter, ...{ deliveryPartner: value } })
      }
   }
   return (
      <>
         <Loading isLoading={isLoading} />
         <Row>
            <Col span={24}>
               <Row className="row-container-head">
                  <Col xs={24} md={8}>
                     <Input.Search onSearch={handleChangeTextSearch} placeholder={t(GLOBAL_CLIENT.search)} allowClear />
                  </Col>
                  <Col xs={24} md={4}>
                     <Select
                        value={fieldFilter.deliveryPartner}
                        placeholder="Chọn DVVC"
                        onChange={handleChangeRole}
                        style={{ minWidth: 120 }}
                     >
                        <Select.Option key={''} value={''}>
                           {'Tất cả'}
                        </Select.Option>
                        {DELIVERY_CONST.map((DELIVERY: any) => {
                           return (
                              <Select.Option key={DELIVERY.value} value={DELIVERY.value}>
                                 {DELIVERY.label}
                              </Select.Option>
                           )
                        })}
                     </Select>
                  </Col>
                  <Col xs={24} md={12}>
                     <div className="text-right">
                        <Space>
                           {/* <Button type="primary" className="btn-add" onClick={showCreate}>
                              <i className="icon icon-add icon-in-button" />

                              {t(GLOBAL_CLIENT.create)}
                           </Button> */}
                        </Space>
                     </div>
                  </Col>
               </Row>

               <Space
                  className="total-items"
                  style={{ width: '100%', alignItems: 'center', justifyContent: 'space-between' }}
               >
                  <span>
                     {t(GLOBAL_CLIENT.totalItems)}: {count}
                  </span>
               </Space>

               <Table
                  scroll={{ x: 1500, y: height - 280 }}
                  columns={columns}
                  dataSource={rows}
                  rowKey="id"
                  pagination={false}
               />

               {renderPagination()}
            </Col>
         </Row>
      </>
   )
})

export default ShipManagement
